import * as React from 'react';

import { useErrorReporter } from '@mdlinx/frontend-shared';
import { PasswordResetForm, PasswordResetFormProps } from 'app/components/login-forms';

import { ResetPasswordError } from 'generated/client';
import { useConfirmPasswordReset } from 'lib/effect-hooks';
import { messages } from 'lib/messages';

export const ResetPasswordHandler: React.FC<{
  oobCode: string;
  onSuccess: () => void;
  onClickBack?: () => void;
}> = ({ oobCode, onSuccess, onClickBack }) => {
  const errorReporter = useErrorReporter();
  const confirmPasswordReset = useConfirmPasswordReset();
  const [error, setError] = React.useState<string | undefined>(undefined);

  const handleSubmit: PasswordResetFormProps['onSubmit'] = (values, actions) => {
    const { newPassword } = values;
    setError(undefined);

    return confirmPasswordReset({ oobCode, newPassword })
      .then(
        result => {
          switch (result.__typename) {
            case 'ResetPasswordSuccess':
              return onSuccess();
            case 'ResetPasswordFailure':
              switch (result.error) {
                case ResetPasswordError.ExpiredOobCode:
                case ResetPasswordError.InvalidOobCode:
                  return setError(messages.error.resetPassword.invalidOobCode);
                case ResetPasswordError.WeakPassword:
                  return setError(result.message || messages.error.resetPassword.unknown);
                case ResetPasswordError.Unknown:
                  return setError(messages.error.resetPassword.unknown);
              }
          }
        },
        e => {
          errorReporter.report(e);
          setError('Oops! Something went wrong!');
        },
      )
      .finally(() => actions.setSubmitting(false));
  };

  return <PasswordResetForm onSubmit={handleSubmit} onClickBack={onClickBack} errorMessage={error} />;
};
